import useQueryOnce from 'hb-react/shared/hooks/useQueryOnce';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const fetchTimezoneOptions = () =>
  axios
    .get(Routes.search_timezones_path({ format: 'json' }))
    .then(({ data }) => data);

export const useTimezones = () => {
  const { isLoading, data } = useQueryOnce('timezones', fetchTimezoneOptions);

  return {
    data,
    isLoading,
  };
};
